export default __webpack_public_path__ + "static/media/DSAutomobilesBold.387419ee.otf";